import { j as e } from "../../../_virtual/jsx-runtime.js";
import o from "../../../assets/icons/index.js";
const u = (r, t) => t || (r ? o[r] : null), l = ({
  iconName: r,
  iconComponent: t,
  ...s
}) => {
  const n = u(r, t);
  return n ? /* @__PURE__ */ e.jsx(n, { className: "flex-shrink-0", ...s }) : null;
};
l.displayName = "Icon";
export {
  l as default
};
